import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, Teleport as _Teleport, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-dd4b7fad"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "nge-dataset-panel" }
const _hoisted_2 = { class: "nge-ds-header" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "nge-ds-title" }, "Switch Dataset", -1 /* HOISTED */))
const _hoisted_4 = { class: "nge-ds-list" }
const _hoisted_5 = ["onClick"]
const _hoisted_6 = { class: "nge-ds-card-label" }
const _hoisted_7 = { class: "nge-ds-card-desc" }
const _hoisted_8 = {
  key: 0,
  class: "nge-ds-badge"
}

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  return (_openBlock(), _createBlock(_Teleport, { to: "body" }, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _hoisted_3,
        _createElementVNode("button", {
          class: "nge-ds-close",
          onClick: _cache[0] || (_cache[0] = $event => ($setup.emit('hide')))
        }, "×")
      ]),
      _createElementVNode("div", _hoisted_4, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.DATASETS, (ds) => {
          return (_openBlock(), _createElementBlock("div", {
            key: ds.id,
            class: _normalizeClass(["nge-ds-card", {
            'nge-ds-active': ds.id === $setup.currentDatasetId,
            'nge-ds-switching': $setup.switching,
          }]),
            onClick: $event => ($setup.switchTo(ds))
          }, [
            _createElementVNode("div", _hoisted_6, _toDisplayString(ds.label), 1 /* TEXT */),
            _createElementVNode("div", _hoisted_7, _toDisplayString(ds.description), 1 /* TEXT */),
            (ds.id === $setup.currentDatasetId)
              ? (_openBlock(), _createElementBlock("div", _hoisted_8, "Active"))
              : _createCommentVNode("v-if", true)
          ], 10 /* CLASS, PROPS */, _hoisted_5))
        }), 128 /* KEYED_FRAGMENT */))
      ])
    ])
  ]))
}